module.exports = __webpack_public_path__ + "resources/img/b-know-how-img-01.3a474322.jpg";